import { useApolloClient } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';
import { Session } from '../../state/Session';
import { useCallback } from 'react';
import { sessionSubject } from '../../state/sessionObservable';
import useBehaviorSubjectState from '../rxjs/useSubjectState';
import { SubNavigatorName } from '../login/useInitialScreen';
import { setSession } from '../../state/preferences';
import { AuditLogTags } from '@oolio-group/audit-sdk';
import { logCdsEvent } from '../../actionLogging/cdsAudit';
import { clearStoredVirtualTerminal } from '../../utils/tap2PayVirtualTerminal';

export const useLogout = () => {
  const { setValue } = useBehaviorSubjectState(sessionSubject);
  const client = useApolloClient();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigation = useNavigation<any>();

  const logout = useCallback(() => {
    logCdsEvent({
      actionType: 'DEVICE_LOGGED_OUT',
      tag: AuditLogTags.DEVICE,
      phrase: 'logged out from the settings menu',
    });
    void clearStoredVirtualTerminal();
    setSession({} as Session);
    setValue({} as Session);
    client.cache.reset();
    navigation.navigateDeprecated(SubNavigatorName.Login);
  }, [navigation, setValue, client]);

  return { logout };
};
